import { getDB } from "./schema";
import type { Message } from "./types";

export async function putMessage(msg: Message): Promise<void> {
  const db = await getDB();
  await db.put("messages", msg);
}

export async function listMessagesByConversation(
  conversationId: string,
): Promise<Message[]> {
  const db = await getDB();
  const all = await db.getAllFromIndex(
    "messages",
    "by-conversation",
    conversationId,
  );
  return all.sort((a, b) => a.createdAt - b.createdAt);
}

export async function deleteMessage(id: string): Promise<void> {
  const db = await getDB();
  await db.delete("messages", id);
}
